<div class="card-container d-flex flex-column">
  <div class="conteudo d-flex flex-column justify-content-end align-items-center gap-2">
    <img class="" src="assets/images/icons/documento.svg" alt="Documento">
    <h4 class="text-center">{{ title }}</h4>
  </div>
  <div class="d-flex justify-content-center">
    <p *ngIf="isApp">Acesse o App Vivest Previdência para ver os documentos deste plano</p>

    <button *ngIf="!isApp" class="btn justify-content-center align-items-center gap-3" [ngClass]="{
          'btn-download': download,
          'btn-direction': direction
          }" (click)="onButtonClick()">
      {{ buttonLabel }}
    </button>
  </div>
</div>
